import React from "react"

import {IonItemGroup, IonItemSliding, IonList} from "@ionic/react"

import {useLocks as useItems}    from '../../contexts/LockContext'
import {LockType as ItemType}    from '../../types/Lock'

import {default as ItemSkeleton} from "./ListItemSkeleton"
import {default as Item}         from "./ListItem"
import ListItemNoResult          from "../common/Items/ListItemNoResult"


const List: React.FC = () => {
    const { items, loadingItems } = useItems()

    const skeletonList = () => {
        return [...Array(6)].map((item, index) => {
            return (
                <IonItemGroup key={index}>
                    <ItemSkeleton/>
                </IonItemGroup>
            );
        })
    }

    const itemList = (items: ItemType[]) => {
        if (items.length === 0 ) {
            return <ListItemNoResult />
        }

        return items.map((item) => {
            return (
                <IonItemSliding key={item.id}>
                    <Item item={item} />
                </IonItemSliding>
            );
        })
    }

    return (
        <IonList>
            { items === undefined || loadingItems
                ? skeletonList()
                : itemList(items)
            }
        </IonList>
    )
}

export default List